<template>
<div>
  <TopMenu></TopMenu>
  <SearchBox></SearchBox>
  <br>
  <br>
  <br>
  <br>
  <br>
    <router-link to="ChangeSeason">跳转到季节页面</router-link>

</div>
</template>

<script>
import SearchBox from "@/views/components/SearchBox.vue";
import TopMenu from "@/views/components/TopMenu.vue";




export default {
  name: "BaiDu",
  components: {TopMenu, SearchBox},
  methods:{

  }

}
</script>

<style scoped>
</style>